import { Module } from 'src/domain';
import { useProductLine } from './useProductLine';

export const useProductLineName = (module?: Module) => {
    const productLine = useProductLine(module);

    return productLine?.name;
};
